"use client";

import { RichText } from "@components/cms/rich-text-renderer/RichText";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";

export const ReturnLabel = (): JSX.Element | null => {
    const { siteSettings } = useGlobalContent();

    const description = siteSettings.product.returnLabel?.description;

    if (!description) return null;
    return <RichText data={description} />;
};
